import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import DashboardLayout from './components/DashboardLayout';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/adminShell.css';

// === Admin Pages ===

import CustomerRegister from './components/CustomerRegister';
import DashboardHome from './pages/admin/DashboardHome';
import ContactsPage from './pages/admin/ContactsPage';
import CategoriesPage from './pages/admin/CategoriesPage';
import CampaignPage from './pages/admin/CampaignPage';
import ImportContactsPage from './pages/admin/ImportContactsPage';
import LogsPage from './pages/admin/LogsPage';
import MessagesPage from './pages/admin/MessagesPage';


function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) setUser(JSON.parse(savedUser));
  }, []);

  // Default route redirection based on role
  const getDefaultRoute = (role) => {
    switch (role) {
      case 'admin':
        return '/dashboard/super-admin/home';
      case 'executive':
        return '/dashboard/executive/home';
      case 'student':
        return '/dashboard/customer/home';
      default:
        return '/';
    }
  };

  return (
    <Router>
      <Routes>
        {/* === LOGIN === */}
        <Route
          path="/"
          element={
            user ? (
              <Navigate to={getDefaultRoute(user.role)} replace />
            ) : (
              <LoginPage setUser={setUser} />
            )
          }
        />
        <Route
          path="/register"
          element={
            user ? (
              <Navigate to={getDefaultRoute(user.role)} replace />
            ) : (
              <CustomerRegister />
            )
          }
        />
        {/* === DASHBOARD LAYOUT (Shared) === */}
        <Route
          path="/dashboard/*"
          element={
            user ? (
              <DashboardLayout user={user} setUser={setUser} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        >
          {/* ADMIN ROUTES */}
          <Route
            path="super-admin/home"
            element={
              <RoleProtectedRoute user={user} allowedRoles={['admin']}>
                <DashboardHome />
              </RoleProtectedRoute>
            }
          />
           <Route
            path="super-admin/contacts-list"
            element={
              <RoleProtectedRoute user={user} allowedRoles={['admin']}>
                <ContactsPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="super-admin/category-management"
            element={
              <RoleProtectedRoute user={user} allowedRoles={['admin']}>
                <CategoriesPage />
              </RoleProtectedRoute>
            }
          />
              <Route
            path="super-admin/campaign"
            element={
              <RoleProtectedRoute user={user} allowedRoles={['admin']}>
                <CampaignPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="super-admin/import-contacts"
            element={
              <RoleProtectedRoute user={user} allowedRoles={['admin']}>
                <ImportContactsPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="super-admin/logs"
            element={
              <RoleProtectedRoute user={user} allowedRoles={['admin']}>
                <LogsPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="super-admin/messages"
            element={
              <RoleProtectedRoute user={user} allowedRoles={['admin']}>
                <MessagesPage />
              </RoleProtectedRoute>
            }
          />
        </Route>

        {/* CATCH-ALL */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
